import React from 'react'

import { bottles } from 'src/axious/bottles'
import { BottleType } from 'src/pages/Bottle/Bottles.types'
import { handleAxiosError } from 'src/utils/errorHandling'

import { Bottle, NoBottles } from '../../components'

interface Props {
  variant: 'created' | 'participated' | 'charitable'
  className?: string
}

const OtherBottles: React.FC<Props> = ({ variant, className }) => {
  const [otherBottles, setOtherBottles] = React.useState<BottleType[]>([])

  React.useEffect(() => {
    const getBottles = async () => {
      try {
        const res = await bottles('get', `/${variant}?status=active`)
        setOtherBottles(res)
      } catch (err) {
        const errorMessage = handleAxiosError(err)
        console.log(errorMessage)
      }
    }

    getBottles()
  }, [])

  return (
    <>
      {otherBottles.length === 0 && (
        <NoBottles variant={variant === 'created' ? 'no_own_bottles' : 'no_participations'} />
      )}
      <div className={className}>
        {otherBottles.map((bottle) => (
          <Bottle {...bottle} />
        ))}
      </div>
    </>
  )
}

export default OtherBottles
